import { get } from "@insite/client-framework/Services/ApiService";
import { Vendor } from "@tKgpco/Store/Data/Vendors/VendorsState";

export const url = "/api/v2/vendor";

export async function getVendors() {
    try {
        const result = await get<Vendor[]>(`${url}`);
        return result;
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
